import { render, staticRenderFns } from "./MakeAPolicyChange.vue?vue&type=template&id=7e14ef29&scoped=true&"
import script from "./MakeAPolicyChange.vue?vue&type=script&lang=ts&"
export * from "./MakeAPolicyChange.vue?vue&type=script&lang=ts&"
import style0 from "./MakeAPolicyChange.vue?vue&type=style&index=0&id=7e14ef29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e14ef29",
  null
  
)

export default component.exports